<app-auth-page-layout>
  <app-forgot-password-form class="flex flex-col flex-1 w-full overflow-y-auto lg:w-1/2 no-scrollbar"/>
</app-auth-page-layout>